import registry from '../generated/perm-registry.json'

/**
 * 权限判定来自注册表（registry/perm-registry.json，由技术方案 §6.2 生成），
 * 前端不自行维护权限码副本，避免「原型一套、实现一套」。
 */
interface PermissionDefinition {
  code: string
  domain: string
  description: string
  default_roles: string[]
  abac: boolean
}

const definitions = registry as unknown as PermissionDefinition[]
let currentPolicy: Record<string, string[]> | null = null
export function setPermissionPolicy(policy: Record<string, string[]> | null): void { currentPolicy = policy }

export const allPermissions = definitions.map((d) => d.code)

export function rolesFor(code: string): string[] {
  return definitions.find((d) => d.code === code)?.default_roles ?? []
}

export function can(roles: string[], code: string): boolean {
  if (!allPermissions.includes(code)) return false
  if (currentPolicy) return roles.some((role) => currentPolicy![role]?.includes(code))
  return rolesFor(code).some((role) => roles.includes(role))
}

export function isRegistered(code: string): boolean {
  return allPermissions.includes(code)
}
